module.exports = __webpack_public_path__ + "static/img/brige01.de84e619.svg";